import React from 'react';
import {Platform, View} from 'react-native';
import {
  Banner,
  BannerButton,
  BannerContainer,
  Bold,
  Bolder,
  ButtonBack,
  ButtonBackText,
  ButtonConfirm,
  ButtonConfirmText,
  ButtonContainer,
  Container,
  ContainerStationHeader,
  ModalBody,
  ModalContent,
  ModalFooter,
  Paragraph,
  Title,
} from './styles';

import bannerVr from '../../../assets/images/banners/vr-header.webp';

import {SafeAreaView} from 'react-native-safe-area-context';
import {useNavigation} from '@react-navigation/native';

// No webview não existe <SafeAreaProvider>, então o SafeAreaView do
// react-native-safe-area-context quebra. Na web usamos uma View simples.
const FooterSafeArea = Platform.OS === 'web' ? View : SafeAreaView;

interface Props {
  showModal: boolean;
  onDismiss: () => void;
}

export function ValeModal({showModal, onDismiss}: Props) {

  const navigation = useNavigation();

  function handleConfirm() {
    navigation.navigate('AddCreditCard', {voucher: true});
    onDismiss();
  }

  return (
    <Container
      isVisible={showModal}
      onBackButtonPress={onDismiss}
      onBackdropPress={onDismiss}>
      <ModalContent>
        <ContainerStationHeader>
          <BannerContainer>
            <BannerButton activeOpacity={1}>
              <Banner source={bannerVr} />
            </BannerButton>
          </BannerContainer>
        </ContainerStationHeader>
        <ModalBody>
          <Title>Pague com seu benefício VR Combustível</Title>

          <Paragraph>
            Cadastre o seu VR Combustível e <Bolder>use o benefício para abastecer
            online.</Bolder> O Baratão é o primeiro app do Brasil a aceitar VR
            Combustível no pagamento online, trazendo mais praticidade e
            inovação para você.
          </Paragraph>

          <Paragraph>
           <Bolder>Como funciona:</Bolder>
          </Paragraph>
            <Paragraph>
           - Cadastre seu cartão VR Combustível ou Multi no app;{'\n'}
          - Escolha o VR como forma de pagamento na hora de abastecer.
          </Paragraph>
            <Paragraph />
        </ModalBody>
        <ModalFooter>
          <FooterSafeArea>
            <ButtonContainer>
              <ButtonBack onPress={onDismiss} activeOpacity={0.7}>
                <ButtonBackText>Fechar</ButtonBackText>
              </ButtonBack>
              <ButtonConfirm
                onPress={() => handleConfirm()}
                activeOpacity={0.7}>
                <ButtonConfirmText>Adicionar cartão</ButtonConfirmText>
              </ButtonConfirm>
            </ButtonContainer>
          </FooterSafeArea>
        </ModalFooter>
      </ModalContent>
    </Container>
  );
}
